// CommonPopup.js
import React, { Component } from 'react';
import Parse from 'parse';
import $ from "jquery";
import Picker from 'emoji-picker-react';
import { MentionsInput, Mention } from 'react-mentions';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle';
import SaveNotification from "./saveNotification.jsx";
function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 's', 1], // 60
      [120, '1m', '1 minute from now'], // 60*2
      [3600, 'm', 60], // 60*60, 60
      [7200, '1h', '1 hour from now'], // 60*60*2
      [86400, 'h', 3600], // 60*60*24, 60*60
      [172800, '1d', 'Tomorrow'], // 60*60*24*2
      [604800, 'd', 86400], // 60*60*24*7, 60*60*24
      [1209600, '1w', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'w', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, '1m', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'm', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, '1y', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'y', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
   
    ];
    var seconds = (+new Date() - time) / 1000,
      token = '',
      list_choice = 1;

    if (seconds == 0) {
      return ''
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      //token = 'from now';
      token = '';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + '' + format[1] + '' + token;
      }
    return time;
  }

class CommonPopup extends Component {
  constructor(props) {
        super(props);
  this.state = {
      //data: null,
      isPopupOpenCommon: false,
      loading_common: false,
      error_common: null,
      post_common_id:'',
      postDetailscomment_common: null,
      postDetails_common: null,
      loadingdata_common:false,
      postData:'',
      likeuserlist:[],
      followersListing: {},
      followinguserid:[],
      inputText: '',
      showPicker: false,
      reply_id:'',
      //loadingdata:false,
      singlelikeCountChild:0,
      loader:false,
      reply_thread_id:'',
      followinglikeuserid:[],
      followerslikeListing: {},
      singlelikeCount:0,
      singleget_allusers_popup:[],
      isChallenge: "0",
      showPicker: false,
      singlementioned_popup:'',
      reply_id:'',
      commentCount: 0,
      singleget_allusers:[],
      previousUrl: '',
      isNotificationOpen:false,
      post_Notification_Id:'',
      post_Notification_Msg:'',
      post_Notification_Comment:''
  };
  this.getUserProfileImage();
  this.handleGetLikePost = this.handleGetLikePost.bind(this);
  this.handlePhotoUnLike = this.handlePhotoUnLike.bind(this);  
  this.handlePhotoActivityLike = this.handlePhotoActivityLike.bind(this);
  this.handleGetActivityLikePost = this.handleGetActivityLikePost.bind(this);
  this.handlePhotoActivityUnLike = this.handlePhotoActivityUnLike.bind(this);
 // this.handleGetLikeUser = this.handleGetLikeUser.bind(this);
  this.deletePostId = this.deletePostId.bind(this); 
  this.singlePostLikeModal = this.singlePostLikeModal.bind(this);  
  this.singlePostLikeModalClose = this.singlePostLikeModalClose.bind(this); 
  this.handleFollowMyProfile = this.handleFollowMyProfile.bind(this);
  this.handleUnFollowMyProfile = this.handleUnFollowMyProfile.bind(this);
  this.handleFollowMyProfileLike = this.handleFollowMyProfileLike.bind(this);
  this.handleUnFollowMyProfileLike = this.handleUnFollowMyProfileLike.bind(this);
  this.updateInputPopup = this.updateInputPopup.bind(this);
  this.handleCommentPostPopup = this.handleCommentPostPopup.bind(this);
  this.handleCommentPostUpdate = this.handleCommentPostUpdate.bind(this);

  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      /*this.props.fetchData().then(response => {
        this.setState({ data: response });
      });*/
      //this.setState({ data: this.props.postcommonid});
      //$('#large_challenge_image_btn_common').trigger('click');
      this.openPopupCommon();
    }
  }
  componentDidMount() {
    // Save the current URL
    this.setState({ previousUrl: window.location.pathname });

  }
deletePostId(post_id) {
        $('#delete_post_id').val(post_id);
      }
 handleUnFollowMyProfile= (e) => {
      var self = this;
     let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result;
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', touser);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                               
                                    setTimeout(() => {                                      
                                       self.singlegetUsersLike(datapost_id);
                                        $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                                        $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                                    },1000);
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
               }
           })
             //setTimeout(() => {
                       // self.singlegetUsersLike(datapost_id);
                         //$('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                         //$('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                    //   },1000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }


    }
 handleSinglePostPopupEnter(event){       
        if (event.key === "Enter") {
          $('.post_button_comment#handleCommentPost_popup').click();
        }
      }

 singlerenderUserSuggestionPopup = (suggestion, search, highlightedDisplay) => (
    <div className="user-suggestion">
      <img src={suggestion.avatar} alt={suggestion.display} className="user-avatar" />
      <div className='details'>
        <span className="displayUserName">{highlightedDisplay}</span>
        <span className="displayName">{suggestion.displayName}</span>
      </div>
    </div>
  );

   toggleNotification = (postid,msg,comment) => {  
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen: !prevState.isNotificationOpen,
          post_Notification_Id: postid,
          post_Notification_Msg: msg,
          post_Notification_Comment:comment 
        }));
        //self.setState({ post_Notification_Id: postid });        
      };

handlePhotoLike = (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
          post_id=$('#popup_post_id_common').val();
          posts_id=$('#popup_post_id_common').val();
        }

        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        { 
            //$('a.liked .default#like_'+post_id).attr("style", "display: none");
            $('a.liked1#like_'+post_id).attr("style", "pointer-events: none");
            var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
             var self = this;
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount===undefined || likeCount===0)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }                         
                            photo_ob.set("likeCountNew", likeCount);      
                            photo_ob.save();
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }                  

                            like.save().then((likeSaved) => {
                                    self.setState({likeCount:likeCount}); 
                                  
                                    $('a.liked .default#like_'+post_id).attr("style", "display: none");
                                    $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                                    if(posts_id)
                                    {
                                       $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: none");
                                       $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: block");          
                                       $('.comment_mn #like_counts_'+posts_id).html(likeCount);

                                       var likesWord = "Likes";
                                       //if (likeCount == 1) likesWord = "Like";
                                        if(likeCount==1)
                                        {
                                          likesWord = "Like";
                                          $('.comment_mn #like_words_'+posts_id).html(likesWord);
                                        }                                       
                                    }
                                    let likeCountNew=likeCount;
                                    $('#like_count_new_common').html(likeCountNew+' '+likesWord);
                                    //$('#home_fetch').trigger('click');
                                     $('#popup_post_id_common').val(posts_id);
                                  // this.handleGetLikePost(post_id);
                                     self.handleGetLikePost(post_id);
                                     self.handleGetLikeUser(post_id);   
                                       
                                   
                            }).catch((error) => {
                            });  
                                                                         
                    } else {
                    }
                }, function(error){
                });
                    setTimeout(() => { 
                    var self = this;
                    this.toggleNotification(post_id,'liked photo','');
                    self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                    },1000);
        }
      }
handleFollowMyProfile = (e) => {
        let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
          var self = this;
        if(currentUser) {
          var query = new Parse.Query('User');
          query.equalTo("objectId", datapost_id);
          query.first().then(function(result){
            if(result) {
              let touser=result;          
              var Activity = Parse.Object.extend("Activity");
              var activity = new Activity();
              activity.set('fromUser', currentUser);
              activity.set('toUser', touser);              
              activity.set('type', 'follow'); 
              activity.save().then((savedFile) => {
                 
                setTimeout(() => {
                  //$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
                  //$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
                 
                  self.singlegetUsersLike(datapost_id);
                  $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                  self.toggleNotification(touser,'started following you.','');
                  self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                  
                },1000);
              }).catch((error) => {
              });              
            }
          })
       
        } else {
          $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }
handleFollowMyProfileLike = (e) => {
        let datapost_id=e.target.dataset.id;
        var self = this;
        const currentUser = Parse.User.current();
        if(currentUser) {
          var query = new Parse.Query('User');
          query.equalTo("objectId", datapost_id);
          query.first().then(function(result){
            if(result) {
              let touser=result;          
              var Activity = Parse.Object.extend("Activity");
              var activity = new Activity();
              activity.set('fromUser', currentUser);
              activity.set('toUser', touser);              
              activity.set('type', 'follow'); 
              activity.save().then((savedFile) => {
                setTimeout(() => {
                  //$('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
                  //$('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                  $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                  self.singlegetUsersCommentLike(datapost_id);           
                  
                },1000);
              }).catch((error) => {
              });              
            }
          })
         // setTimeout(() => {
            //self.singlegetUsersCommentLike(datapost_id);            
          //},2000);
        } else {
          $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }
 handleUnFollowMyProfileLike= (e) => {
     let datapost_id=e.target.dataset.id;
     var self = this;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result;
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', touser);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                                    setTimeout(() => {
                                      $('.followimg_button .following_user.follow_button#followpopup_'+datapost_id).attr("style", "display: none");
                                      $('.followimg_button .follow_user.follow_button#followpopup_'+datapost_id).attr("style", "display: block");
                                       self.singlegetUsersCommentLike(datapost_id);
                                    },1000);
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
               }
           })
             //setTimeout(() => {
              //  self.singlegetUsersCommentLike(datapost_id);
              // },2000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }


    }
singlegetUsersLike(post_id) {
  let currentUser = Parse.User.current();
  if(currentUser)
  {

  //following
    var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     //console.log(user.get("fromUser").id);
                     //console.log(user.get("toUser").id);
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinguserid: followingdataresult1});                      
                    }
               }else{
                  self.setState({followinguserid: []});  
               }
            }
        })

   //followers 
   var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (followerresult.length > 0)
               {
                       let userdataresult = [];                      
                       //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});
                        
               }
            }
        })
  }else{
    var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (resultcount > 0)
               {
                      let userdataresult = [];                      
                      //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});
                        
               }
            }
        })

  }


  }
  singlePostLikeModal() {
    var self = this;
        let post_id=$('#popup_post_id_common').val();
        console.log(post_id+'post_id');
        this.singlegetUsersLike(post_id);
        $("body").addClass("sngl_mdlpstlk_open");        
      }
  checkDeletePost() {
        let delete_post_id= $('#delete_post_id').val();  
        const currentUser = Parse.User.current();
        if(currentUser) {
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', delete_post_id);
          console.log(delete_post_id);
          const queryString = window.location.href;

          var self = this;
          query.find().then(function(photo){
            if(photo) {
                let photo_ob=photo[0];
                var checklikequery = new Parse.Query('Like');  
                checklikequery.equalTo('photo', "Photo$"+delete_post_id);
                checklikequery.find().then((object) => {
                    if (object) {
                        for (const objects of object) {
                              objects.destroy();
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 

                var checkActivityquery = new Parse.Query('Activity');  
                checkActivityquery.equalTo('photo', "Photo$"+delete_post_id);
                checkActivityquery.find().then((object) => {
                    if (object) {
                          for (const objects of object) {
                              objects.destroy();
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                var checkSavequery = new Parse.Query('Save');  
                checkSavequery.equalTo('photo', "Photo$"+delete_post_id);
                checkSavequery.find().then((object) => {
                    if (object) {
                        for (const objects of object) {
                              objects.destroy();
                        }                       
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                  if(photo_ob)
                  {
                      photo_ob.destroy();  
                  }
                    setTimeout(() => {
                      //window.location.href = "/";
                       window.location.href = queryString;
                    },1000);             
            }
          })  
        }
      }
  getUserProfileImage() {
        const currentUser = Parse.User.current();
        if (currentUser) {
           let profile_picture = currentUser.get("profilePictureSmall");
           if(profile_picture)
             { 
                 this.state.currentuserImage = profile_picture.url();
             }
               this.state.currentUserId = currentUser.id;
        }   
      }
   handleGetLikeUser = (post_id) => {
         if(post_id)
         {
          var like = new Parse.Query('Like');
          var self = this; 
          like.equalTo('photo', 'Photo$'+post_id);
          like.doesNotExist('activity');

          like.find().then(function(result){
              if(result)
              {              
                self.setState({likeuserlist:result}); 
              }              
          })
        }          
      }
    
  formatRenderComments2main(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (comp.indexOf("#") !== -1)
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                //var userdisplayname = comp.replace('#','');
                let linkdata='<a>'+comp+'</a>';
                buffer.push(linkdata);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            } else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
             /* var userdisplayname = comp.replace(/\s/g, "").replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  */
                const regex = /@(\w+)/g;
                const linkedText = comp.replace(regex, '<a href="/user/$1">@$1</a>');
                buffer.push(linkedText); 
            }

            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
        var content=buffer.join(' ');
             return ({'a':<span className='cmt-txt'>
                        {/*  {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}
                          {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
              {content}
                             </span>});
          //return <img src={"https:aaaa"} />
        
      }

handleGetActivityLikePost = (comment_id) => {
         var check_value=0;
         let post_id=this.state.post_common_id;//this.state.postID;
         const currentUser = Parse.User.current();
         if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.include("activity");
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('activity',"Activity$"+comment_id);
            checklikequery.equalTo('fromUser', currentUser);    
            var self = this;
           
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;                    
                    if(resultLikedid!==undefined)
                    { 
                       $(' a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: none");
                       $('a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: block"); 
                       $('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style", "display: block"); 
                      // $(' a.liked_activity#comment_'+comment_id).attr("disabled", false);
                       /*if ($('a.liked_activity#comment_'+comment_id).hasClass('disabled'))
                       {
                         $('a.liked_activity#comment_'+comment_id).removeClass('disabled'); 
                       }*/
                       $('a.liked_activity#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }   
                    if(resultLikedid===undefined){  
                       $('a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: block");
                       $('a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: none"); 
                        $('.comment_userimg_inner .like.box.maincomment#'+comment_id).attr("style", "display: none"); 
                    }                            
                }
            })
        }
      }
      handlePhotoActivityUnLike = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
              if(!getLoggedinUsername)
              {
                  $('#kitchenQrModal_btn').trigger('click');    
                  return false;
              }else
              {
                  let  post_id=e.target.id;
                  let datapost_id=e.target.dataset.id;
                  //$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
                  $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: none");
                  var query = new Parse.Query('Activity');  
                  query.equalTo('objectId', datapost_id);
                  var self = this;
                  query.find().then(function(activity){
                          if(activity)
                          {
                              let activity_ob=activity[0];
                              let likeCount;
                              if (activity_ob) {
                                likeCount = activity_ob.get('likeCount');
                              } else {
                                likeCount =0;
                              }   
                              if(likeCount===undefined || likeCount===0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }                     
                              /*if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }*/
                              let photo_ob= activity_ob.get('photo');
                              activity_ob.set("likeCount", likeCount);
                              activity_ob.save();
                              //like 
                                  let currentUser = Parse.User.current(); 
                                  let currentUser_id=currentUser.id;                          
                                  var checklikequery = new Parse.Query('Like');  
                                  checklikequery.equalTo('photo', photo_ob); 
                                  checklikequery.equalTo('fromUser', currentUser);  
                                  checklikequery.equalTo('activity', activity_ob);
                                  checklikequery.first()
                                    .then((object) => {
                                      if (object) {
                                        return object.destroy();
                                      } else {
                                          $('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                          $('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                           $('.comment_userimg_inner .like.box.maincomment#'+datapost_id).attr("style", "display: none");
                                      }
                                    })
                                    .then((deletedObject) => {
                                        //self.setState({likeCount:likeCount});  
                                        //$('#home_fetch').trigger('click');
                                        self.setState({singlelikeCount:likeCount}); 
                                      $('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                      $('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                       $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: auto");
                                      
                                    })
                                    .catch((error) => {
                                      console.error('Error deleting record:', error);
                                    });  
                              //like  
                          }
                      })
                  setTimeout(() => {
                            var self = this;
                            self.handleGetActivityLikePost(datapost_id);
                      },500);
              }
      }
  // updateInputPopup(event){
     updateInputPopup = (event) => {
        //console.log('updateInputPopup');
          var reply_id=$('#reply_id').val();
          if(reply_id==='')
          {
            //console.log('singlementioned_popup==='+event.target.value)
            this.state.singlementioned_popup='';
          }
         var self = this;
       
         this.setState({singlementioned_popup: event.target.value});
             
         this.setState({postcomment_popup : event.target.value});
         this.setState({ inputText: event.target.value });
         if(event.target.value!== null && reply_id==='') {
         
         } else {
          //console.log('Test2');
         }   

      }
      handlePhotoActivityLike = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
            let  post_id=e.target.id;
            let datapost_id=e.target.dataset.id;
            //$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
            //$('a.liked_activity .activitydefault#comment_'+datapost_id).attr("disabled", true);
            //if(('a.liked_activity .activitydefault#comment_'+datapost_id).attr('disabled') === 'true'){  return;}
            $('a.liked_activity#comment_'+datapost_id).attr("style", "pointer-events: none");
            //e.stopImmediatePropagation();
            

            var query = new Parse.Query('Activity');  
            query.equalTo('objectId', datapost_id);
            var self = this;

            query.find().then(function(activity){
                    if(activity)
                    {
                        let activity_ob=activity[0];
                        let activity_ob_comment=activity_ob.get('content');
                        let likeCount;
                        if (activity_ob) {
                           likeCount = activity_ob.get('likeCount');
                        } else {
                           likeCount =0;
                        }                        
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }
                         let photo_ob= activity_ob.get('photo');
                         activity_ob.set("likeCount", likeCount); 
                         activity_ob.save();
                         //like 
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set('activity', activity_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }
                             like.save().then((likeActivitySaved) => {      
                                    //if ($('a.liked_activity#comment_'+datapost_id).hasClass('disabled')){ return false;}               
                                    self.setState({singlelikeCount:likeCount}); 
                             }).catch((error) => {
                            });
                         //like  
                       
                      self.toggleNotification(post_id,'liked comment',activity_ob);
                      self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 
                     }
                 })
            setTimeout(() => {
                      var self = this;
                           console.log('activity like setTimeout');
                      self.handleGetActivityLikePost(datapost_id);

                 },500);
        }
      }
openPopupCommon = (e) => {
      var postId=this.props.postcommonid;
       $('#popup_post_id_common').val(postId);
       
        this.setState({ isPopupOpenCommon: true,post_common_id:postId }, () => {
          this.fetchPostDataCommon(postId);
        });
      }


 singlegetAllUsersPopup() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.exists("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                     //userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     //self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                     self.state.singleget_allusers_popup.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                 }
                     this.state.singleget_allusers_popup=userdataresult1;
            }else {
               // console.log("No users found");
            }
        }, function(error){
        });
       
  }
 singlegetAllUsers() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                     //userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     //self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                     self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,'displayName':user.get("displayName")});
                 }
                     this.state.singleget_allusers=userdataresult1;
            }else {
               // console.log("No users found");
            }
        }, function(error){
        });
       
  }
  handleGetSavePost = (post_id,page) => {

        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id_common').val();
           post_id=posts_id;
        }
        var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;        
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Save');  
          checksavequery.equalTo('photo', "Photo$"+post_id);
          checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
          checksavequery.find().then(function(resultSave){
              if(resultSave)
              {             
                  let resultSaved=resultSave[0];
                  resultSavedid= resultSaved.id;
                  let photo_id= resultSaved.get('photo').id;
                  if(resultSavedid)
                  {  
                      //$('.active#save_'+post_id).attr("style", "display: block"); 
                      //$('.default#save_'+post_id).attr("style", "display: none"); 
                      //$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
                      $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                      $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: block");
                      $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: auto"); 
                      if(posts_id)
                      {
                          $('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style", "display: none"); 
                          $('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style", "display: block");
                      }

                     
                  }  
              }
          })
        }
      }
  fetchPostDataCommon = async (postId) => {
        this.setState({ loading_common: true, error_common: null });
        try {
          const Post = Parse.Object.extend('Photo');
          const query = new Parse.Query(Post);
          const post = await query.get(postId);
          
          let userlikelist=[];
          var query1 = new Parse.Query('Activity');
          query1.equalTo('photo', "Photo$"+postId);
          query1.equalTo("type", "comment");
          query1.include("fromUser");
          query1.include("photo");
          query1.include("image");
          query1.include("content");
          query1.include("_created_at");
          query1.include("createdAt");

          query1.doesNotExist("activity");
          query1.ascending("_created_at");
          var self = this;
          
          query1.find().then(function(result){
            if(result) {  
                  
              let commentdataresults=[]; 
              for (var i = 0; i < result.length; i++) {
                let userActivitylist=[];
                var comment = result[i];
                var replyQuery = new Parse.Query('Activity');
                replyQuery.equalTo('photo', "Photo$"+postId);
                replyQuery.exists("activity");
                replyQuery.equalTo('activity', "Activity$"+comment.id);
                replyQuery.include("photo");
                replyQuery.ascending("_created_at");
                replyQuery.find().then(function(result){
                  if(result) {  
                    const processedData = result.map((result) => {
                      return {
                        id:result.id,
                        content:result.get('content'),
                        createdAt:result.get('createdAt'),
                        fromUser:result.get('fromUser'),
                        likeCount:result.get('likeCount'),
                        toUser:result.get('toUser'),
                        type:result.get('type'),
                        updatedAt:result.get('updatedAt'),
                      };
                    });
                    userActivitylist.push(processedData);
                  }
                })
                commentdataresults.push({comments:comment,
                  children: userActivitylist,
                });

              }
              
              self.setState({
                postDetailscomment_common: commentdataresults,
                postDetails_common: post,
                loading_common: false,
                loadingdata_common:true
              });
              let obj = post.get('caption')!=''?self.formatRenderComments2main(post.get('caption')):self.formatRenderComments2main(post.get('caption'));   
              let full_text=obj.a.props.children?obj.a.props.children:'';
              $('#full_text_common').html(full_text);
              
              $('#lef_img_common').attr('src','../images/default_userpic0.png');
              $('.popup_user_image_common').attr('src','../images/default_userpic0.png');
              $('.popup_display_userimage_common').attr('src','../images/default_userpic0.png');

              $('.user_name a.popup_user_name_common').html('');
              $('.user_name a.popup_user_name_common').html(post.get('user').get('displayUsername'));
              $('.user_name a.popup_user_name_common').attr("href", "/user/"+post.get('user').get('displayUsername')) ;
              $('.popup_display_username_common').html(post.get('user').get('displayUsername'));
              $('.popup_display_username_common').attr("href", "/user/"+post.get('user').get('displayUsername')) ;
              let userprofileimage=post?post.get('user')?post.get('user').get('profilePictureSmall')?post.get('user').get('profilePictureSmall').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';

              $('.popup_user_image_common').attr('src',userprofileimage);
              $('.popup_display_userimage_common').attr('src',userprofileimage);
              let photo_img =post?post.get('image')?post.get('image')?post.get('image').url():'../images/default_userpic0.png':'../images/default_userpic0.png':'../images/default_userpic0.png';

              $('#lef_img_common').attr('src',photo_img);
              let likeCountNew=post.get('likeCountNew')?post.get('likeCountNew'):0;
              var likesWord = "Likes";
              if (likeCountNew == 1){likesWord = "Like"; } 
              $('#like_count_new_common').html(likeCountNew+' '+likesWord);
              $('.time_interval_new_common').html(time_ago(post.get('createdAt')));
               document.getElementById('large_challenge_image_common_btn').click();      

              self.singlegetAllUsersPopup();
             
              self.handleGetSavePost(post.id,'popup'); 
              self.singlegetUsersLike(post.id); 
              self.handleGetLikeUser(postId);    
               /*url update*/
             //count update
              var postimpt=post?post.get('impr')+1:1;
              post.set('impr', postimpt);
              post.save().then((postupdated) => {
              });
              //count update
              //let stateObj = { postId: postId }; 
            //  window.history.replaceState("", "","/post/"+postId); 
               window.history.pushState(null, '', "/post/"+postId);

              /*url update*/
              if (post.get("isChallenge")) {
                 this.setState({isChallenge: post.get("isChallenge")});
              }

             
              
              

            
            } else {
            }
          
          }, function(error){
        });
          
      
        } catch (err) {
          this.setState({
          loading_common: false,
          });
        }
      };
   /*singlePostModalClose1Common() {
      console.log('singlePostModalClose1Common');
        this.setState({isPopupOpenCommon: false,
            postDetails_common: null,
            postDetailscomment_common: null});
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $("body").removeClass("modal-open");
        $('#popup_post_id_common').val('');
        this.setState({loading_common: false});  
      } */
       toggleExpand(commentId) {
        this.setState((prevState) => ({
            isExpanded: !prevState.isExpanded
        }));
         this.setState((prevStates) => ({
            expandedCommentId: commentId
        }));
      }
      formatRenderComment(origComment,comnt_id, comment_id) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=250;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);
             var self = this;
            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
               // buffer.push(<a href={comp}>{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {

              /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  
             }
            else
            {
                 // buffer.push(<span>{comp} </span>);  
                 //buffer.push(comp+' ');  
                 buffer.push(comp);               
            }
        }
        var content=buffer.join(' ');
            /* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/

        const {  showMoreText = 'more', showLessText = 'less' } = this.props;
        const { isExpanded } = this.state;
        const { expandedCommentId } = this.state;


        // Determine whether to truncate the text
        const shouldTruncate =content.length > maxLength && !isExpanded;
        
        // Truncate the text if necessary  //expandedCommentId===comment_id
        
           
        let  displayText =  shouldTruncate ? content.slice(0, maxLength) + '...' : content        
        return ( <span className='cmt-txt' id={comment_id}>
          {/*{buffer}*/} 
          {/*   {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "") }...` :content}*/}




          {/*  {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
          {/*expandedCommentId===comment_id*/}
          {/*displayText*/}<span dangerouslySetInnerHTML={{ __html: displayText }} />
          {/* {displayText}*/}
          {shouldTruncate   && (
              <button onClick={() => this.toggleExpand(comment_id)} style={{ color: '#868589', cursor: 'pointer', border: 'none', background: 'none' }}>
                  {isExpanded ? showLessText : showMoreText}
              </button>
          )}
          </span>
        );
      }
  handleCommentClick= () => {
   $('.add_in_comment #comment_box_popup').focus(); 
 }
  handleNotLoginClick = () => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }
      }
  handleRemoveSavePost= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id_common').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername) {
            //window.alert('You need to login to save post.');
            return false;
        }else {
          $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: none"); 
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', post_id);
          query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined ||  saveCount < 0)
                         { 
                             saveCount=0;
                         }else
                         {
                            saveCount=saveCount-1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);         
                            photo_ob.save();
                            let currentUser = Parse.User.current(); 
                            var checklikequery = new Parse.Query('Save');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } else {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                                }
                              })
                              .then((deletedObject) => {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                                     $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: auto"); 
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });      
                    } else {
                        //console.log("No post found");
                    }

                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
                     setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                     },1000);
        }
      }
   handleSavePost = (post_id,page) => {

        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id_common').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            //window.alert('You need to login to save post.');
            return false;
        }else
        {
        $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: none");    
        var query = new Parse.Query('Photo');  
        query.equalTo('objectId', post_id);
         var self = this;
        query.find().then(function(photo){
            //$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined)
                         {
                             saveCount=1;
                         }else
                         {
                            saveCount=saveCount+1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);                          
                            photo_ob.save();
                            var Save = Parse.Object.extend("Save");
                            var save = new Save();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            save.set('fromUser', currentUser);
                            save.set('photo', photo_ob);
                            save.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             save.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             save.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            //acl.setWriteAccess(photo_ob.get('user'), true); 
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            save.setACL(acl);
                            save.save().then((savedFile) => {
                                 //  window.alert('You Saved post.');
                                 //  window.location.href = "/";
                            }).catch((error) => {
                            });        
                            self.toggleNotification(post_id,'saved photo','');
                            self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});                 
                    } else {
                        //console.log("No post found");
                    }


                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
         setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                          /*if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }*/
                     },1500);
        }
      }
     
  handleGetLikePost = (post_id) => {
        var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.equalTo('photo', "Photo$"+post_id);
            //checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
            checklikequery.equalTo('fromUser', currentUser);  
            //checklikequery.notContainedIn("activity");   
            checklikequery.doesNotExist("activity");
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;
                    if(resultLikedid!==undefined)
                    {  
                       $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: none");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: block"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: none");
                       $('a.liked1#like_'+post_id).attr("style", "pointer-events: auto");
                    }
                    if(resultLikedid===undefined){                     
                       $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: block");

                       $('.comment_like_shere a.liked1 .active1#like_'+post_id).attr("style", "display: none"); 
                       $('.comment_like_shere a.liked1 .default1#like_'+post_id).attr("style", "display: block"); 
                    }                              
                }
            })
      }
      }
  handlePhotoUnLike= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           //post_id=post_id;
           //post_id=$('#popup_post_id').val();
           //posts_id=$('#popup_post_id').val();
          post_id=$('#popup_post_id_common').val();
          posts_id=$('#popup_post_id_common').val();
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
         //$('a.liked .active#like_'+post_id).attr("style", "display: none");
          $('a.liked1#like_'+post_id).attr("style", "pointer-events: none");
         const currentUser = Parse.User.current();
         if (currentUser) { 
         var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
            //query.equalTo('user', currentUser);
            var self = this;  
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount==undefined || likeCount==1)
                         {
                             likeCount=0;
                         }else
                         {
                            likeCount=likeCount-1;
                         }                          
                            photo_ob.set("likeCountNew", likeCount);  
                            photo_ob.save();  
                            var checklikequery = new Parse.Query('Like');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                   $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                  if(posts_id)
                                  {
                                     $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }
                                 
                                } else {
                                    /*$('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                    $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                    if(posts_id)
                                    {
                                      $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }*/
                                }
                              })
                              .then((deletedObject) => {
                                  self.handleGetLikeUser(post_id);
                                  self.handleGetLikePost(post_id);
                                 
                                  self.setState({likeCount:likeCount});  
                                        
                                  //self.setState({likeCount1:likeCount}); 
                                  //$('#home_fetch').trigger('click');
                                  $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                   if(posts_id)
                                  {
                                  $('.comment_like_shere a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                  $('.comment_like_shere a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                                                   
                                  var likesWord = "Likes";
                                  if (likeCount == 1) likesWord = "Like";
                                   $('.comment_mn #like_counts_'+posts_id).html(likeCount);
                                   $('.comment_mn #like_words_'+posts_id).html(likesWord);
                                   $('a.liked1#like_'+post_id).attr("style", "pointer-events: auto");
                                  /*if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                   
                                  }*/
                                  }                                
                                  let likeCountNew=likeCount;
                                  $('#like_count_new_common').html(likeCountNew+' '+likesWord); 
                                  //$('#popup_post_id').val(posts_id);  
                                                          
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
                              $('#home_fetch').trigger('click');      
                                           
              }
          });
              /*setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(post_id);
                           if(posts_id)
                           {                            
                             self.handleGetLikeUser(posts_id); 
                           }                                                  
                      },1500);*/
                    /*  setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);                          
                     },2000);*/
      }
        }
      }
faqOpenClose(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        var self = this;
        var check = $(".view_replies_comment .faq-drawer #faq-drawer-"+commenUpdatedId).is(":checked");
        if(check) {
          $(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('Hide Replies');
         
          $('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).addClass('active');
        } else {
          $(".view_replies_comment .faq-drawer label.faq-drawer__title span#faq-"+commenUpdatedId).html('View Replies');
          if ($('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).hasClass("active")) {
            $('.view_replies_comment .faq-drawer .faq-drawer__content-wrapper#fq-'+commenUpdatedId).removeClass('active');
          }
        }
      }
      singlePostLikeModalClose() {
        $("body").addClass("modal-open1");
        $("body").removeClass("sngl_mdlpstlk_open");

       // console.log("Test");
      }
   singlePostLikeModalLikes(main_activity_id) {
        let post_id=$('#popup_post_id_common').val();        
        this.singlegetUsersCommentLike(post_id,main_activity_id);
           setTimeout(() => {
            $('#large_challenge_like_list_likes').trigger('click');
          },500); 
        $("body").addClass("sngl_mdlpstlk_open");
      }
  singlegetUsersCommentLike(post_id,main_activity_id) {
  let currentUser = Parse.User.current();
  if(currentUser)
  {

  //following
    var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     //console.log(user.get("fromUser").id);
                     //console.log(user.get("toUser").id);
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinglikeuserid: followingdataresult1});                      
                    }
               }else{
                  self.setState({followinglikeuserid: []});  
               }
            }
        })

   //followers 
   var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('activity', "Activity$"+main_activity_id);
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (followerresult.length > 0)
               {
                       let userdataresult = [];                      
                       //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followerslikeListing: userdataresult});
                        
               }
            }
        })
  }else{
    var followersquery = new Parse.Query('Like');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.doesNotExist("activity");
        followersquery.equalTo('activity', "Activity$"+main_activity_id);
        followersquery.equalTo('photo', "Photo$"+post_id);
        //followersquery.equalTo("fromUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (resultcount > 0)
               {
                      let userdataresult = [];                      
                      //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followerslikeListing: userdataresult});
                        
               }
            }
        })

  }


  } 
    handleGetActivityLikePostChild = (comment_id) => {
    //console.log('handleGetActivityLikePostChild click'+comment_id);
         var check_value=0;
         let post_id=this.state.post_common_id;//this.state.postID;
         const currentUser = Parse.User.current();

         if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.include("activity");
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('activity',"Activity$"+comment_id);
            checklikequery.equalTo('fromUser', currentUser);    
           
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];                   
                    resultLikedid= resultLiked.id;        
                    if(resultLikedid!==undefined)
                    {  
                       $(' a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style", "display: none");
                       $('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style", "display: block"); 
                       $('.like.box.childcomment#child_'+comment_id).attr("style", "display: block");
                       //$('.comment_like  .comment.box a .reply_count#comnt_'+comment_id).trigger('click');
                       
                       $('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }   
                    if(resultLikedid===undefined){  
                       $('a.liked_activity_child .activitydefault#comment_'+comment_id).attr("style", "display: block");
                       $('a.liked_activity_child .activityactive#comment_'+comment_id).attr("style", "display: none"); 
                        $('.like.box.childcomment#child_'+comment_id).attr("style", "display: none");
                        $('.comment_user_content .liked_activity_child#comment_'+comment_id).attr("style", "pointer-events: auto");
                    }    

                }
            }) 
            // this.state.singlementioned_popup='';
          /*  var reply_id=$('#reply_id').val();
         if(reply_id==='')
          {
           this.state.singlementioned_popup='';
          }*/
            
             //setTimeout(() => {
                        //  var self = this;
                       //  self.handleCommentPostUpdate();
                    // },1000);
        }
      }
   togglePicker = () => {
        this.setState((prevState) => ({
          showPicker: !prevState.showPicker,
        }));
      };
onEmojiClick = (event, emojiObject) => {
        this.setState((prevState) => ({
          //inputText: prevState.inputText + emojiObject.emoji,
          singlementioned_popup:prevState.singlementioned_popup + emojiObject.emoji,
          showPicker: false, // Optional: hide the picker after selection
        }));
      };
  handlePhotoActivityUnLikeChild = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
              if(!getLoggedinUsername)
              {
                  $('#kitchenQrModal_btn').trigger('click');    
                  return false;
              }else
              {
                  let  post_id=e.target.id;
                  let datapost_id=e.target.dataset.id;
                  //$('a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
                  //console.log('datapost_id'+datapost_id);
                  
                  $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: none");
                  var query = new Parse.Query('Activity');  
                  query.equalTo('objectId', datapost_id);
                  var self = this;
                  query.find().then(function(activity){
                          if(activity)
                          {
                              let activity_ob=activity[0];
                              let likeCount;
                              if (activity_ob) {
                                likeCount = activity_ob.get('likeCount');
                              } else {
                                likeCount =0;
                              }                        
                              if(likeCount===undefined || likeCount===0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }
                              let photo_ob= activity_ob.get('photo');
                              activity_ob.set("likeCount", likeCount);
                              activity_ob.save();
                              //like 
                                  let currentUser = Parse.User.current(); 
                                  let currentUser_id=currentUser.id;                          
                                  var checklikequery = new Parse.Query('Like');  
                                  checklikequery.equalTo('photo', photo_ob); 
                                  checklikequery.equalTo('fromUser', currentUser);  
                                  checklikequery.equalTo('activity', activity_ob);
                                  checklikequery.first()
                                    .then((object) => {
                                      if (object) {
                                        return object.destroy();
                                      } else {
                                          $('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                          $('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                          $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                      }
                                    })
                                    .then((deletedObject) => {
                                        //self.setState({likeCount:likeCount});  
                                        //$('#home_fetch').trigger('click');
                                        self.setState({singlelikeCountChild:likeCount});
                                        var likesWord = "Likes";
                                        if (likeCount == 1){ likesWord = "Like";}
                                        $('.like.box .count#childlike_'+datapost_id).html(likeCount);  
                                        $('.like.box .like_count#childlike_'+datapost_id).html(likesWord);  
                                        $('.like.box .like_count#childlike_'+datapost_id).attr("style", "display: none"); 

                                      $('a.liked_activity_child .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                     $('a.liked_activity_child .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                     $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: auto");
                                     if(likeCount===0)
                                     {
                                      $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                     }
                                     
                                      
                                    })
                                    .catch((error) => {
                                      console.error('Error deleting record:', error);
                                    });  
                              //like  
                          }
                      })
                  setTimeout(() => {
                            var self = this;
                            self.handleGetActivityLikePostChild(datapost_id);
                      },2000);
              }
      }

  handlePhotoActivityLikeChild = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
            let  post_id=e.target.id;
            let datapost_id=e.target.dataset.id;
            $('.comment_user_content .liked_activity_child#comment_'+datapost_id).attr("style", "pointer-events: none");
            var query = new Parse.Query('Activity');  
            query.equalTo('objectId', datapost_id);
            var self = this;
            query.find().then(function(activity){
                    if(activity)
                    {
                        let activity_ob=activity[0];
                        let likeCount;
                        if (activity_ob) {
                           likeCount = activity_ob.get('likeCount');
                        } else {
                           likeCount =0;
                        }                        
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }
                         let photo_ob= activity_ob.get('photo');
                         activity_ob.set("likeCount", likeCount); 
                         activity_ob.save();
                         //like 
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set('activity', activity_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }
                             like.save().then((likeActivitySaved) => { 
                             var likesWord = "Likes";
                             if (likeCount == 1){ likesWord = "Like";}
                             $('.like.box .count#childlike_'+datapost_id).html(likeCount);  
                             $('.like.box .like_count#childlike_'+datapost_id).html(likesWord); 
                             if(likeCount===0)
                                     {
                                      $('.like.box.childcomment#child_'+datapost_id).attr("style", "display: none");
                                     }                  
                                    self.setState({singlelikeCountChild:likeCount}); 
                             }).catch((error) => {
                            });
                         //like  
                          self.toggleNotification(post_id,'liked comment',activity_ob);
                          self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});    
                     }
                 })
            setTimeout(() => {
                      var self = this;
                      self.handleGetActivityLikePostChild(datapost_id);
                 },2000);
           
        }
      }    
handleCommentPostPopup = function(e){
        const currentUser = Parse.User.current();
        if(currentUser) {
        $('.post_button_comment#handleCommentPost_popup').attr("disabled", true);
        var self = this;
        
        e.preventDefault();
        
        //$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");
      
        var Photo = Parse.Object.extend("Photo");
        var query = new Parse.Query(Photo);

        let photo_post_id=this.state.post_common_id;
        var postcomment=this.state.singlementioned_popup;//this.state.postcomment_popup;
        let reply_id=this.state.reply_id;//$('#reply_id').val();
        let activity_parent_id=$('#activity_parent_id').val();
        
        if(postcomment) {
          query.include("user");
          query.include("image");
          query.include("thumbnail");
          query.include("likeCountNew");
          query.include("saveCount");
          query.include("commentcount");
          query.include("_created_at");
          query.include("createdAt");
          query.exists("user");
          query.descending("createdAt");
          
          query.find({
            success: function(results) {
              if (results.length > 0) {
                self.setState({ loader: true });

                results.forEach(function(photo) {                               
                  if( photo.id===photo_post_id)
                  {
                      var Activity = Parse.Object.extend("Activity");
                      var activity = new Activity();
                      let currentUser = Parse.User.current(); 
                      activity.set('fromUser', currentUser);
                      activity.set('toUser', photo.get("user"));
                      activity.set('content', postcomment);                 
                      activity.set('type', 'comment');   
                      if(reply_id)
                      {
                        activity.set('activity', 'Activity$'+activity_parent_id);
                      }        
                      activity.set('photo', photo);    
                      activity.set('likeCount', 0);  
                      
                      let currentUser_id=currentUser.id;                
                    
                        try {
                        activity.save().then((savedActivity) => {
                          const activityId = savedActivity.id;
                          self.setState({reply_thread_id:activityId});

                         // setTimeout(() => {
                             // $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
                              //$('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
                             
                         // },1000);  
                           if(reply_id)
                          {
                          self.toggleNotification(photo_post_id,'commented post reply',savedActivity);
                        }else{
                           self.toggleNotification(photo_post_id,'commented post',savedActivity);
                        }
                         // self.toggleNotification(photo_post_id,'commented post',savedActivity);
                          self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});    

                          let captionusername='';
                          let captionusernameupdated='';
                          if(postcomment)
                          {
                             captionusername = postcomment.match(/@\w+/);
                               if (captionusername) {
                                captionusernameupdated=captionusername[0].substr(1);
                                 if(captionusernameupdated)
                              {
                                //self.toggleNotification(photo_post_id,'tagged you in a comment',savedActivity);
                                self.toggleNotification(photo_post_id,'mentioned you in a comment',savedActivity);
                                self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''});  
                              } 
                              }             
                          }  
                           
                                          
                        }).catch((error) => {
                         
                        });

                        $(".comment_box_popup").val('');
                        $("#comment_box_popup").val('');
                        var updated_photo_id=photo.get('id');
                        const Photo_single = Parse.Object.extend("Photo");
                        const Photoquery = new Parse.Query(Photo_single);
                        const photoId = photo.id;
                        Photoquery.get(photoId)
                          .then(photo => {
                            var commentcount_val=parseInt(photo.get('commentcount'));
                            if(isNaN(commentcount_val))
                            {
                                commentcount_val=0;
                            }                             
                            var updated_comment_count=commentcount_val+1;
                            photo.set("commentcount", updated_comment_count.toString());
                            self.setState({commentCount:updated_comment_count.toString()});
                            photo.save();      
                            self.setState({singlementioned_popup:''});  

                          
                          })
                          .catch(error => {                       
                          });
                             setTimeout(() => {
                              self.setState({singlementioned_popup:'',reply_id:''});
                              self.handleCommentPostUpdate(); 
                          },500);
            
                    } catch (error) {                       
                    }                     
                  }
                });
        

              } else {
              }
              
            },
            error: function(error) {
            }
          });
       

         
         
        }
        var self = this;
        let post_id=$('#popup_post_id_common').val();
      }else
      {
        $('#kitchenQrModal_btn').trigger('click');  
          return false;
      }
      
      }
  handleCommentPostLikes = () => {
         let post_id=this.state.post_common_id;
         const currentUser = Parse.User.current();

         if (currentUser) {
            const currentUser_id = currentUser.id;     
             var query_activityChild = new Parse.Query('Activity'); 
             query_activityChild.equalTo('photo', "Photo$"+post_id); 
             query_activityChild.exists("activity");
             query_activityChild.find().then((resultactivity) => {

             let resultactivitys=resultactivity;
               for (const objects of resultactivitys) {
                        setTimeout(() => {
                          if(objects.get('likeCount')===0){  
                             $('a.liked_activity_child .activityactive#comment_'+objects.id).attr("style", "display: none"); 
                              $('a.liked_activity_child .activitydefault#comment_'+objects.id).attr("style", "display: block");
                              $('.like.box .count#childlike_'+objects.id).html(0);  
                              $('.like.box .like_count#childlike_'+objects.id).html('Likes');
                          }
                    },1000);
                  }
          })
          }
     }
  deleteCommentIdOverlay(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        $('#delete_comment_id').val(commenUpdatedId);
        this.checkDeleteComment();
      }
  checkDeleteComment() {
        let delete_comment_id= $('#delete_comment_id').val();    
        

        const currentUser = Parse.User.current();
        let photo_post_id=this.state.post_common_id;
        var self = this;

        if(currentUser) {
          /*child*/
          var query_activityChild = new Parse.Query('Activity');  
          query_activityChild.equalTo('activity', "Activity$"+delete_comment_id);
          query_activityChild.equalTo('fromUser', currentUser);
          query_activityChild.find().then((object) => {

          if (object) {
            
               for (const objects of object) {
                              objects.destroy();
                              var checklikequery = new Parse.Query('Like');  
                              checklikequery.equalTo('photo', "Photo$"+photo_post_id);
                              //checklikequery.equalTo('fromUser', currentUser);
                              checklikequery.equalTo('activity', "Activity$"+objects.id);
                              checklikequery.find().then((object) => {
                                  if (object) {
                                      for (const objects of object) {
                                            objects.destroy();
                                      }
                                  }
                                })
                                .then((deletedObject) => {

                                })
                                .catch((error) => {
                                  console.error('Error deleting record:', error);
                                });
                        }
              //return object.destroy();
          } 

          }).then((deletedObject) => {
            /*setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);*/
          }).catch((error) => {
            console.error('Error deleting record:', error);
          }); 

          /*child*/

          /*like*/
          var checklikequery = new Parse.Query('Like');  
          checklikequery.equalTo('photo', "Photo$"+photo_post_id);
          //checklikequery.equalTo('fromUser', currentUser);
          checklikequery.equalTo('activity', "Activity$"+delete_comment_id);
          checklikequery.find().then((object) => {
              if (object) {
                  for (const objects of object) {
                        objects.destroy();
                  }
              }
            })
            .then((deletedObject) => {

            })
            .catch((error) => {
              console.error('Error deleting record:', error);
            });

        /*like*/




          var query_activity = new Parse.Query('Activity');  
          query_activity.equalTo('objectId', delete_comment_id);
          //query_activity.equalTo('fromUser', currentUser);
          query_activity.first().then((object) => {

          if (object) {
              //var photo_obj_id= object.get('photo').id;         
              /*photo*/
              /*var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });*/
              /*photo*/
              return object.destroy();
          } 

          }).then((deletedObject) => {

           /* var getActivityquery = new Parse.Query('Activity');  
          getActivityquery.equalTo('objectId', delete_comment_id);
          var self = this;
          getActivityquery.find().then(function(activitydata){
          if(activitydata)
          {
              let activity_ob=activitydata[0];
              console.log(activity_ob.length);
            }
          })*/
        
        var query = new Parse.Query('Activity');
        let reply_id=this.state.reply_id;
        query.equalTo('photo', "Photo$"+photo_post_id);
        query.equalTo("type", "comment");
        //query.doesNotExist("activity");
        query.include("fromUser");
        query.include("photo");
        
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
       
        query.descending("_created_at");
        var self = this;

        query.find().then(function(result){
            if(result){
                let totalcomment=result.length;
                //console.log(totalcomment+'totalcomment')
                var getPhotoquery = new Parse.Query('Photo');  
                var self = this;
              getPhotoquery.equalTo('objectId', photo_post_id);
              getPhotoquery.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var commentcount= totalcomment?totalcomment:0;
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                     self.setState({commentCount:commentcount.toString()});
                     // setTimeout(() => {
                      //var self = this;
                     // this.handleCommentPostUpdate();
                    //},1000);
                  }
              });

              }
            });

        



            setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },2000);
          }).catch((error) => {
            console.error('Error deleting record:', error);
          }); 
        }   
      }
   handleCommentPostUpdate = async () => {
        //$(".add_in_comment .emoji_icon_input_row .textarea_bottom.active").attr("style", "visibility: hidden");   
        //$('.add_in_comment #comment_box_popup').attr("style", "color: transparent");
        //$('.add_in_comment #comment_box_popup').attr('placeholder','Add a comment...');
        let photo_post_id=this.state.post_common_id;
        let reply_thread_id=this.state.reply_thread_id;
        var self = this;

        var query = new Parse.Query('Activity');
        let reply_id=this.state.reply_id;
        query.equalTo('photo', "Photo$"+photo_post_id);
        query.equalTo("type", "comment");
        query.doesNotExist("activity");
        query.include("fromUser");
        query.include("photo");
        query.limit(999999999);
        
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
      
        //query.descending("_created_at");
        query.ascending("_created_at");
        let commentCountval=this.state.commentCount;
        
        query.find().then(function(result){
          let commentdataresults1=[]; 
          if(result){
            let totalcomment=result.length;
            let totalcommentchild=0;
            self.setState({singlementioned_popup: ''});
            self.setState({comments: result});
              
            for (var i = 0; i < result.length; i++) {    
              let userActivitylist=[];
              var comment = result[i];  
              var comment_idsval=comment.id;
              var replyQuery = new Parse.Query('Activity');
              replyQuery.equalTo('photo', "Photo$"+photo_post_id);
              replyQuery.exists("activity");
              replyQuery.equalTo('activity', "Activity$"+comment.id);
              replyQuery.include("photo");
              replyQuery.ascending("_created_at");
             // replyQuery.descending("_created_at");
              replyQuery.find().then(function(result) {

                if(result) {
                  //totalcommentchild=result.length;
                  var processedData = result.map((result) => {
                    return {
                      id:result.id,
                      content:result.get('content'),
                      createdAt:result.get('createdAt'),
                      fromUser:result.get('fromUser'),
                      likeCount:result.get('likeCount'),
                      toUser:result.get('toUser'),
                      type:result.get('type'),
                      updatedAt:result.get('updatedAt'),
                    };
                  });
                  userActivitylist.push(processedData);
                }  

                //self.handleGetActivityLikePostChild(comment_idsval) ; 
                //self.handleGetActivityLikePost(result.id); 
              })    

              commentdataresults1.push({comments:comment,
                children: userActivitylist,
              });
              
              /*setTimeout(() => {
                if(comment.id) {
                  // $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                    self.handleGetActivityLikePostChild(comment.id)
                }
              },1000); */
            }

            setTimeout(() => {
              self.setState({ postDetailscomment_common: commentdataresults1 }, () => {
                self.setState({loadingdata_common: true,loading_common: false,singlementioned_popup: '',loader:false,reply_id: '' });
              });
              if(reply_thread_id) {
                $(' a.liked_activity_child .activitydefault#comment_'+reply_thread_id).attr("style", "display: block");
                $('a.liked_activity_child .activityactive#comment_'+reply_thread_id).attr("style", "display: none");
                $('.like.box .count#childlike_'+reply_thread_id).html(0);  
                $('.like.box .like_count#childlike_'+reply_thread_id).html('Likes'); 
              }
              self.setState({ reply_thread_id: '' });
               setTimeout(() => {
                          self.handleCommentPostLikes();  
                          $('#activity_parent_id').val(''); 
                        },500); 
               $('.post_button_comment#handleCommentPost_popup').attr("disabled", false);
            },3500); 

            $('#reply_id').val('');
          
            //self.setState({ reply_id: '' });
            //self.setState({singlementioned_popup: ''});
            //self.setState({commentCount:totalcomment});
            //console.log('totalcomment'+totalcomment)
            //self.setState({postDetailscomment: result});
            //self.renderDetailPage(photo_post_id);
            /*setTimeout(() => {
                if(commentdataresults1) {
                  for (var i = 0; i < commentdataresults1.length; i++) {
                    var commentdataresults1 = commentdataresults1[i]; 
                    let comment= commentdataresults1.comments; 
                    console.log('comment');
                    console.log(comment);
                    console.log('.comment_like  .comment.box a .reply_count#comnt_'+comment.id);
                    $('.comment_like  .comment.box a .reply_count#comnt_'+comment.id).trigger('click');
                  }
                }
              },1000); */                  
            /*setTimeout(() => {
              self.setState({reply_id: ''});
              $('#reply_id').val('');
              $(".add_in_comment #comment_box_popup").val('');
              self.setState({singlementioned_popup: ''});
                $('#clearInput').trigger('click');                 
              },2000); */  
          } else {
          }
        }, function(error){});

        var getPhotoquery = new Parse.Query('Photo');  
        getPhotoquery.equalTo('objectId', photo_post_id);
        var self = this;
        getPhotoquery.find().then(function(photo){
          if(photo) {
            let photo_ob=photo[0];
            let commentcount =photo_ob.get('commentcount')?photo_ob.get('commentcount'):0;
            self.setState({commentCount:commentcount});
            photo_ob.set("commentcount", commentcount.toString());
            photo_ob.save();
          }
        }) 
        
      } 
   replyComment = (commentId,activity_parent_id,event) => {
        
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];

        $('#reply_id').val(commenUpdatedId);  
        $('#activity_parent_id').val(activity_parent_id); 
        this.setState({reply_id: commenUpdatedId});
        let reply_id=$('#reply_id').val();
        var query1 = new Parse.Query('Activity');
        query1.equalTo('objectId', commenUpdatedId);
        query1.equalTo("type", "comment");
        query1.include("fromUser");
        var self = this;
        $('.add_in_comment #comment_box_popup').val('');            
        let activity_parent_ids=$('#activity_parent_id').val();

        query1.find().then(function(photo){
          if(photo) {
            let photo_ob=photo[0];
            let displayusername=photo_ob?photo_ob.get('fromUser')?'@'+photo_ob.get('fromUser').get('displayUsername')+'  ':'':'';
            let displayusernameval=photo_ob?photo_ob.get('fromUser')?photo_ob.get('fromUser').get('displayUsername'):'':'';
            
            self.setState({singlementioned_popup:displayusername}); 
              
          }
        });
        setTimeout(() => {
          if(activity_parent_ids==='' && reply_id==='') {
            self.setState({singlementioned_popup:''}); 
              $('#clearInput').trigger('click');
          }            
        },2000); 
        $('.add_in_comment #comment_box_popup').focus(); 
      }

  getCommentProfilePicCommon(comment) {
          var user = comment.get("fromUser");
          if (user && (user != undefined))
          {
            var pic = user.get("profilePictureSmall");
            if (pic && (pic != undefined))
              return pic.url()
          }
          return "/images/default_userpic0.png";
      }
   renderDetailPageCommon = (post_id) => {
        const { postDetails_common,postDetailscomment_common,likeuserlist,inputText, showPicker,loadingdata_common,loader } = this.state;
        let othertext='';
        let bufferdata_common = [];
        let bufferdatacommentreply = [];   
        let userlikeusername = [];
        let fetchuserlikeusername = [];
        let bufferfollowers=[];
        let bufferlikefollowers=[];
        const formatRenderCommentChild  = (origComment,comnt_id, comment_id) => {  
          let buffer = [];
          if (!origComment) {
            return (
              <div>
                {buffer}
              </div>
            );
          }

          var stringSplit = origComment.split(" ");
          var maxLength=250;

          for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);
             var self = this;
            if (firstChar == "#") {
              buffer.push(comp);
            } else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1)) {
              buffer.push(comp);
            } else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1)) {
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
              buffer.push(linkdata);  
            } else {
              buffer.push(comp);               
            }
          }
          
          var content=buffer.join(' ');
          const {  showMoreText = 'more', showLessText = 'less' } = this.props;
          const { isExpanded } = this.state;
          const { expandedCommentId } = this.state;
          const shouldTruncate =content.length > maxLength && !isExpanded;
           
          let  displayText =  shouldTruncate ? content.slice(0, maxLength) + '...' : content        
          return (
            <span className='cmt-txt' id={comment_id}>
            <span dangerouslySetInnerHTML={{ __html: displayText }} />
              {shouldTruncate   && (
                <button onClick={() => this.toggleExpand(comment_id)} style={{ color: '#868589', cursor: 'pointer', border: 'none', background: 'none' }}>
                    {isExpanded ? showLessText : showMoreText}
                </button>
              )}
            </span>
          );
        }


       const singlePostModalClose1Common= () =>  {
       /*url update*/
        
        var current_weburl=$('#current_weburl').val();
        var search_txt_box=$('#search_txt_box').val();
        var current_weburls=this.state.previousUrl;

        //console.log(this.state.previousUrl+'previousUrl');
        
        if(search_txt_box!=='' && current_weburl.includes('search'))
        {
          // window.history.replaceState("","", current_weburl+'?q='+search_txt_box);
           setTimeout(() => {  
          window.history.replaceState("","", '/search?q='+search_txt_box);
            }, 500);
        }else{
          setTimeout(() => {  
           window.history.replaceState("","", current_weburls);
             }, 500);
        }
    
        //window.history.replaceState("","", current_weburl);  

        /*url update*/
         
        $('#closepopup_common').click();
        this.setState({isPopupOpenCommon: false,
            postDetails_common: null,
            postDetailscomment_common: null});
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $("body").removeClass("modal-open");
        $("body").removeClass("modal-open-search");
        $("body").removeClass("modelopenexplore");
        $('#popup_post_id_common').val('');
        //tabopenarray.length = 0; 
        //$('#closepopupsingle').click();
         
        this.setState({loading_common: false});           
      } 
        const clearInput = () => {
          console.log('clearInput');
          var self = this;
          self.setState({singlementioned_popup: ''});
        };

        const getCommentProfilePicChild = (comment) => { 
          var user = comment.fromUser;
          if (user && (user != undefined)) {
            var pic = user.get('profilePictureSmall');
            if (pic && (pic != undefined))
              return pic.url()
          }
          return "/images/default_userpic0.png";
        }
        
        if(this.state.postDetailscomment_common) {
          if(this.state.postDetailscomment_common.length>0) {
            let buffercommentdata = [];  
            for (var i = 0; i < this.state.postDetailscomment_common.length; i++) {
              var comment = this.state.postDetailscomment_common[i]; 

              let children= comment.children!==undefined?comment.children[0]:''; 
              comment= comment.comments;
              
              let comment_activity_id="comment_"+comment.id;
              let comment_id="comnt_"+comment.id;
              let comment_par_id="comnt_"+comment.id;
              let likeCount=comment.get("likeCount")?comment.get("likeCount"):0;
              var likesWord = "Likes";
              if (likeCount == 1) likesWord = "Like";
              let comment_fromuserid= comment.get("fromUser").id;
              let comment_currentUserId= this.state.currentUserId;
              const hasKey = comment.has('activity');  
              var self = this;
              let main_activity_id=comment.id;

              
              
              bufferdata_common.push(               
                <div key={69*i} className="cmt_wrap">
                  <div className="detail_bottom user_top_row">
                    <div className="user_top_card">
                    
                      {hasKey==false?
                        <div className="user_inline_row">
                          <div className="user_leftbar_img">
                            <div className="user_img">
                              <span className="user_icon"><img src={this.getCommentProfilePicCommon(comment)}/>  </span>
                            </div>
                            <div className="user_name_wrapper">
                           
                              <div className="user_inner">
                                <div className="user_name">
                                  {comment.get("fromUser")?comment.get("fromUser").get('displayUsername')?<a href={'/user/' + comment.get("fromUser").get('displayUsername')}>{comment.get("fromUser").get('displayUsername')}</a>:'':''} 
                                  {hasKey==false?
                                  <span className="content-span">  <span className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</span></span>:<span>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)} </span> }
                                </div>
                                <div className="user_sidebar_heart">
                                  {this.handleGetActivityLikePost(comment.id)}

                                  {likeCount==0?
                                    <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                                    </a>
                                    :
                                    <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityUnLike(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>
                                      <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                                    </a>
                                  }
                        
  <div className="like box maincomment"   id={comment.id}   style={({display: likeCount===0 ? 'none' : 'block'})}
                                       >
                                       
                                        <a href="javascript:;" id="like_button_challenge"  onClick={(e)=> { this.singlePostLikeModalLikes(main_activity_id,false)}} ><span className="count">{likeCount}</span><span className="like_count"   style={{ display: "none" }}>{likesWord}</span></a>
                                      </div>
                                </div>
                                
                              </div>
                            
                                 
                              <div className="product_content_details">
                                                           
                                 {hasKey==false?
                                    <div className="comment_like d-flex flex-row flex-wrap align-items-center"  id={comment_id}>
                                      <div className="day box">
                                     
                                        {time_ago(comment.get("createdAt"))}
                                      </div>
                                     
                                      <div className="comment box" >
                                        <a href="javascript:;"><span className="reply_count" id={comment_id}   onClick={(e) => this.replyComment(comment_id,main_activity_id,e)}  >Reply</span></a>
                                      </div>
                                      <div className="comment box"   style={{ display: "none" }}>
                                        <div className="action cta_btn">
                                          <div className="btn-wrp btn-group more_action three-dot" >
                                            <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                              <img src="/images/small_dot_action.svg" alt="More Option"/>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                        
                                              {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button"  onClick={(e) => this.deleteCommentIdOverlay(comment_id)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report </a> }
                                              <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>                           
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                    </div>
                                  : 
                                    <div>
                                    </div>
                                   }
                             
                                {children!==undefined && children.length>0 && 
                                  <div className="view_replies_comment">
                                 
                                    <div className="faq-drawer">
                                      <input className="faq-drawer__trigger" id={"faq-drawer-"+comment.id} type="checkbox" title={comment_id} onClick={(e) => this.faqOpenClose(comment_id)}  /><label className="faq-drawer__title" htmlFor={"faq-drawer-"+comment.id} ><span id={"faq-"+comment.id}>View Replies </span> <span className="replies_count"  id={"faqreply-"+comment.id}>({children.length})</span> </label>
                                      <div className="faq-drawer__content-wrapper"  id={"fq-"+comment.id}>
                                        <div className="faq-drawer__content">
                                          <ul className="ul_list_replay_user">
                                            {
                                              loadingdata_common && children &&  children.map( function (child, i, row) {
                                                { 
                                                  let comment_fromuserid= child.fromUser.id;
                                                  const currentUser = Parse.User.current();
                                                  let comment_currentUserId='';
                                                  if (currentUser) {
                                                    comment_currentUserId= currentUser.id;
                                                  }
                                                 
                                                  let comment_activity_id_child="comment_"+child.id;
                                                  let comment_id_child="comnt_"+child.id;
                                                  let likeCountChild=child.likeCount?child.likeCount:0;
                                              
                                                  var likesWord = "Likes";
                                                  
                                                  if (likeCountChild == 1) likesWord = "Like";
                                                  
                                                  return (
                                                    <li className="li_list_replay_user"  key={69*i}>
                                                      <div className="comment_replay_row">
                                                        <div className="comment_replay_inner">
                                                          <div className="comment_userimg_inner">
                                                            <div className="comment_user_img">
                                                              <img src={getCommentProfilePicChild(child)}/>
                                                            </div>
                                                            <div className="comment_content_inner">
                                                              <div className="content_replay">
                                                                <span className="title_userName"> {child.fromUser?child.fromUser.get('displayUsername')?<a href={'/user/' + child.fromUser.get('displayUsername')}>{child.fromUser.get('displayUsername')}</a>:'':''} </span>  <span className="content-span">  <span className="cmt_cnt" id={comment_id_child}>{formatRenderCommentChild(child.content,comment_id_child,child.id)}</span>
                                                                </span>
                                                              </div>
                                                              <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                                <div className="day box">
                                                                  <a href="javascript:;">{time_ago(child.createdAt)}</a>
                                                                </div>
                                                                
                                                                <div className="comment box">
                                                                  <a href="javascript:;"><span className="reply_count" id={comment_id_child}   onClick={(e) => self.replyComment(comment_id_child,main_activity_id,e)}  >Reply</span></a>
                                                                </div>
                                                                <div className="comment box"    style={{ display: "none" }} >
                                                                  <div className="action cta_btn">
                                                                    <div className="btn-wrp btn-group more_action three-dot dropup">
                                                                      <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/images/small_dot_action.svg" alt="More Option"/>
                                                                      </button>
                                                                      <div className="dropdown-menu">
                                                                      {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button"  onClick={(e) => self.deleteCommentIdOverlay(comment_id_child)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report </a> }
                                                                        <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>                           
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                               
                                                              </div>
                                                            </div>
                                                            <div className="comment_user_content">
                                                           
                                                              <a  href = "javascript:void(0);"  className='liked_activity_child'  id={comment_activity_id_child} >
                                                                <img data-id={child.id} id={comment_activity_id_child}  onClick={(e) => {self.handlePhotoActivityUnLikeChild(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>            
                                                                <img data-id={child.id} id={comment_activity_id_child}  onClick={(e) => {self.handlePhotoActivityLikeChild(e);}}  className="activitydefault" src="../images/cmt-like.svg" style={{ display: "block" }} />
                                                              </a>
                                                              {self.handleGetActivityLikePostChild(child.id,child)}
                                                           
                                                               <div className="like box childcomment" id={"child_"+child.id}    style={({display: likeCountChild===0 ? 'none' : 'block'})}>
                                                               
                                                                  <a href="javascript:;"  id="like_button_challenge"   onClick={(e)=> { self.singlePostLikeModalLikes(child.id,false)}} ><span className="count" id={"childlike_"+child.id}>{likeCountChild}</span><span className="like_count"   style={{ display: "none" }}  id={"childlike_"+child.id}>{likesWord}</span></a>
                                                                </div>
                                                            </div>
                                                             
                                                          </div>
                                                          
                                                        </div>
                                                      </div>
                                                    </li>
                                                  );
                                                }
                                              })
                                            }
                                          
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>  
                                }
                                                    
                              </div>
                            </div>
                          </div>
                        </div>
                      : ''}
                    </div>
                  </div>
                
               
                </div>
              );
            }
          }
        }
        
      if (this.state.likeuserlist) {    
          var rows = this.state.likeuserlist.length;
          var other=0;
          
          for (var i = 0; i < rows; i++) {  
           var likeuser = this.state.likeuserlist[i]; 
           if(rows>1) { 
            other=rows-1;  
           }  
           if(i==0)
           {
                if (likeuser.get('fromUser') && likeuser.get('fromUser').id!==undefined){
              userlikeusername.push(<span  key={69*i}>
                      <a href={'/user/'+likeuser.get('fromUser').get("displayUsername")} id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list">  {likeuser.get('fromUser').get("displayUsername")}</a>
                      </span>); 
            }
           }
        }
           
        if(userlikeusername)
        {
            fetchuserlikeusername.push(<span  key={69*i}>{userlikeusername!=''?<p className="liked_others"><label>Liked by  {userlikeusername} {rows>1 && other?other==1?<span> and <a id='like_button_challenge' onClick={this.singlePostLikeModal}  type='button' data-toggle='modal' data-target='#large_challenge_like_list'>{other}</a>  other </span>:<span> and <a id='like_button_challenge' onClick={this.singlePostLikeModal}  type='button' data-toggle='modal' data-target='#large_challenge_like_list'>{other}</a>  others </span>:""} </label></p>:''}</span>);  
              
        }
    }
    if(this.state.followersListing) {

      let followinguserid=this.state.followinguserid;           
      var following_match_id=[];                    
      var rows = this.state.followersListing.length;
      if(rows != undefined){
        for (var i = 0; i < rows; i++) {
          var followers = this.state.followersListing[i];
          var follow_id_ms='followpopup_'+followers.id;

          let userimage=null; 
          if(followers.image) {
            userimage=followers.image;
          } else {
            userimage="/images/default_userpic0.png";
          }
          const currentUser = Parse.User.current();  
                    if(currentUser)
                    {
                      let   currentUserid=currentUser.id;
                     var chek = followinguserid.find(c =>{ return c.id === followers.id});
                     
                  
                    var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                
                                bufferfollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                
                                      {currentUserid===followers.id?"":followingresults.id===followers.id?<a href="javascript:void(0);"  className="following_user follow_button "  id={follow_id_ms}  title="UnFollow"   data-id={followers.id}       onClick={(e) => this.handleUnFollowMyProfile(e)}  >Unfollow</a>: <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>}
                                    </div>
                                  </li>
                                );
                                }else{
                                 
                                bufferfollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                 
                                      <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>
                                    </div>
                                  </li>
                                );

                    }
                    
           }
            } 
        }

      if(this.state.followerslikeListing) {

      let followinguserid=this.state.followinglikeuserid;           
      var following_match_id=[];                    
      var rows = this.state.followerslikeListing.length;
      if(rows != undefined){
        for (var i = 0; i < rows; i++) {
          var followers = this.state.followerslikeListing[i];
          var follow_id_ms='followpopup_'+followers.id;

          let userimage=null; 
          if(followers.image) {
            userimage=followers.image;
          } else {
            userimage="/images/default_userpic0.png";
          }
          const currentUser = Parse.User.current();  
                    if(currentUser)
                    {
                      let   currentUserid=currentUser.id;
                     var chek = followinguserid.find(c =>{ return c.id === followers.id});
                     
                  
                    var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                
                                bufferlikefollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                   
                                 
                                   
                                      {currentUserid===followers.id?"":followingresults.id===followers.id?<a href="javascript:void(0);"  className="following_user follow_button "  id={follow_id_ms}  title="UnFollow"   data-id={followers.id}       onClick={(e) => self.handleUnFollowMyProfileLike(e)}  >Unfollow</a>: <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>}
                                    </div>
                                  </li>
                                );
                                }else{
                              
                                bufferlikefollowers.push(
                                  <li  key={69*i}>
                                    <div className="img_like_li">
                                      <div className="like_user_img">
                                      <img className="mr-3"  src={userimage} alt="Generic placeholder image"/>
                                      </div>
                                      <div className="like_user_name">
                                        <h4 className="name"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h4>
                                        <h5 className="name_tagline">{followers.displayUsername}</h5>
                                      </div>
                                    </div>
                                    <div className="followimg_button">
                                
                                      <a   id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => self.handleFollowMyProfileLike(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="follow_user follow_button" >Follow</a>
                                    </div>
                                  </li>
                                );

                    }
                    
           }
            } 
        }


        let getLoggedinUsername=localStorage.getItem('username');
        var post_id_m='save_'+post_id;
        var follow_id_m='follow_'+postDetails_common.get('user').id;
        var currentuserImage=this.state.currentuserImage;
        var post_like_id_m='like_'+post_id;
        var currentUserId=this.state.currentUserId;
        let sameprofile=0;
        if(currentUserId===postDetails_common.get('user').id) {
          sameprofile=1;
        }  
        var isNotificationOpen=this.state.isNotificationOpen; 
        var post_Notification_Ids=this.state.post_Notification_Id; 
        var post_Notification_Msg=this.state.post_Notification_Msg;
        var post_Notification_Comment=this.state.post_Notification_Comment;


    return ( 
    <React.Fragment>      
      <div className="modal fade post_modal post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image_common" id="large_challenge_image_common" data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true" >
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
            <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' onClick={singlePostModalClose1Common} data-dismiss="modal" aria-label="Close" title='Close'>&#x2715;</a>
          </div>
            <div className="modal-body"> 

            <button style={{display:"none"}} href='javascript:void(0);'  type="button" className='btn' data-toggle="modal" data-target="#large_challenge_like_list_likes1"  id="large_challenge_like_list_likes">get </button>
            {isNotificationOpen?<SaveNotification   isOpen={isNotificationOpen}  postNotificationid={post_Notification_Ids} postMsg={post_Notification_Msg} postPhotoid={post_id} postActivityComment={post_Notification_Comment} />:""}  
          

              <div className='inner text-center'>
              <div className="inner_post_row">
                <div className="img_leftSide">
               
                <img id="lef_img_common" src="../images/default_userpic0.png" alt='Comment'/>
                </div>
                <div className="right_side_content_post">
                  <div className="user_top_row border_bottom">
                    <div className="user_top_card">
                      <div className="user_img">
                        <span className="user_icon"><img className="popup_user_image_common" src="../images/default_userpic0.png" alt='img'/></span>
                      </div>
                      <div className="user_name">
                      <a  className="popup_user_name_common" href="#"></a>
                    
                      </div>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                       
                          {sameprofile===1?<div className="post_delete_cm">
                       
                          <a  href='javascript:void(0);'  className="dropdown-item danger" type="button" id="delete_post_with_discardpoup"   onClick={(e) => this.deletePostId(post_id)}  title="Delete"  data-toggle="modal" data-target="#deletePostCloseModalpopup" >Delete</a></div>
                          : <a  href='javascript:void(0);' className="dropdown-item danger" type="button">Report</a>}
                          <a href='javascript:void(0);'  aria-label="Close" className="dropdown-item" type="button"  title="Cancel" >Cancel</a>                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="post_listing_ul_wrap">
                    <ul className="post_listing_ul">
                      <li className="post_listing_li">                        
                        <div className="detail_bottom user_top_row">
                          <div className="user_top_card">
                            <div className="user_inline_row">
                              <div className="user_leftbar_img">
                                <div className="user_img">
                                  <span className="user_icon"><img  className="popup_display_userimage_common" src="../images/default_userpic0.png" alt='img'/></span>
                                </div>
                                <div className="user_name_wrapper">
                                  <div className="user_inner">
                                    <div className="user_name">
                                    
                                      <div></div>
                                      <a href="javascript:;" className="popup_display_username_common"></a>
                                      <span className="cmt_box">
                                        <span className="cmt_cnt">
                                          <span className="cmt-txt" id="full_text_common"></span>
                                        </span>
                                      </span>
                                      <span className="content-span">
                                      
                                      </span>
                                    </div>
                                    <div className="user_sidebar_heart"> </div>
                                  </div>
                                  <div className="product_content_details">
                                    <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                      <div className="day box">
                                        <a href="javascript:;"><span className="time_interval_new_common"></span></a>
                                      </div>
                                      <div className="like box">
                                        <a href="javascript:;" id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list"><span id="like_count_new_common"></span>{}
                                      </a>
                                      </div>
                                      <div className="comment box">
                                    
                                      </div>
                                     
                                    </div>
                                  </div>
                                </div>                              
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="post_listing_li">
                          {bufferdata_common}
                      
                      </li>
                    </ul>
                  </div>
                    <input type="hidden" id="popup_post_id_common" name="popup_post_id_common" value={post_id} />
                <div className="comment_post_bottom_add">
                  {sameprofile===1 && this.state.isChallenge==0?   
                    <div className="create_challenge_row">
                
                                            
                        <a href={'/create-challenge/'+this.state.post_common_id}  className="create_button" title='Create Challenge'>Create Challenge</a>
                        
                    </div>
                      :""}


 
                    <div className="comment_like_shere">
                      <div className="wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                          <div className="action_grp">
                         
                              
                                <input type="hidden" id="popup_load_id" name="popup_load_id"  onClick={() => this.handleLoadPopup(post_id)}  />
                                <input type="hidden" id="reply_id" name="reply_id" />
                                <input type="hidden" id="activity_parent_id" name="activity_parent_id" />
                                <a href ="javascript:void(0);"  className='like-icon liked1'  id={post_like_id_m}>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoLike(post_id,'popup')} className="default1" src="../images/like.svg"/>
                          <img  id={post_like_id_m}  onClick={() => this.handlePhotoUnLike(post_id,'popup')}  className="active1"  style={{ display: "none" }}   src="../images/like-fill.svg"/>{this.handleGetLikePost(post_id)}
                        </a>
                            <a href="javascript:;"  onClick={() => this.handleCommentClick()}  className="comment-icon home-comment">
                              <img src="../images/comment-bold.svg" alt="Comment" />
                            </a>
                            <a href="javascript:;" className="share-icon">
                              <img src="../images/cmt-share-bold.svg" alt="Share" />
                            </a>
                          </div>
                          <div className="post_save1">
                      
                          {getLoggedinUsername!=null?
                          <a href ="javascript:void(0);"  style={{ display: "block" }}  id={post_id_m}  className='savepost_link1' >                   
                            <img id={post_id_m} style={{ display: "block" }} className="savedefault1" src="../images/bookmark.svg" onClick={() => this.handleSavePost(post_id,'popup')} alt='No BookMark' />
                            <img id={post_id_m} style={{ display: "none" }} className="saveactive1" src="../images/bookmark-fill.svg" onClick={() => this.handleRemoveSavePost(post_id,'popup')} alt='BookMark' />
                            {this.handleGetSavePost(post_id,'popup')}
                          </a>
                          : <a href="javascript:void(0);"  onClick={() => this.handleNotLoginClick()}>
                            <img style={{ display: "block" }} className="savedefault1" src="../images/bookmark.svg"  alt='No BookMark' />
                          </a>
                          }
                          </div>
                        </div>                       
                        {fetchuserlikeusername}
                    </div>
        {showPicker && (
          <Picker onEmojiClick={this.onEmojiClick} />
        )}     
                    <div className="add_in_comment">
                      <div className="emoji_icon_input_row">
                       <div className="emogi_icon"> <img src="../images/add_reaction.svg" alt='img'  onClick={this.togglePicker} />
                      </div>
                          <div className="textarea_bottom active">
                            <MentionsInput  placeholder="Add a comment..." value={this.state.singlementioned_popup}  id="comment_box_popup"   onChange={this.updateInputPopup} style={defaultStyle}  onKeyDown={this.handleSinglePostPopupEnter}>
                              <Mention trigger="@" data={this.state.singleget_allusers_popup}   markup="@__display__ "
                                displayTransform={(id, display,displayName) => `@${display}`}
                                appendSpaceOnAdd  style={defaultMentionStyle}  renderSuggestion={this.singlerenderUserSuggestionPopup}
                                required id="comment_box_popup" className="mentions__mention"    placeholder="Add a comment..."/>
                            </MentionsInput>
                            </div>  
                                
                            {this.state.singlementioned_popup===''?<button   id='handleCommentPost_popup' disabled className="post_button_comment" onClick={this.handleCommentPostPopup}>Post</button>:<button   id='handleCommentPost_popup' className="post_button_comment" onClick={this.handleCommentPostPopup}>Post</button>}
                             <button  style={{ display: "none" }}  onClick={clearInput} id="clearInput">Clear Input</button>
                             {this.state.loader && <div className="loading_img"  style={{'position': "absolute", 'top': "50%", 'left': "50%",'transform':"translate(-50%, -50%)"}}   ><img style={{'width': "40px"}}  src="/images/loading-gif.gif" /></div>}
                       
                      </div>
                     {/* <small><p className='comment_message_alert'>{this.state.blank_comment_message_popup}</p></small>*/}
                    </div>
                  </div>
                  
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
      {/*Single Post Overlay Likes Now popup*/}
     <div className="modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image" id="large_challenge_like_list" onKeyDown={this.singlePostLikeModalClose} data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
              <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close"  onClick={this.singlePostLikeModalClose}  title='Close'>&#x2715;</a>
            </div>
            <div className="modal-body">
              <div className='inner text-center'>
              <div className="likes_user_model">
                    <div className="likes_model_row">
                      <h1 className="like_title">Likes</h1>
                      
                    </div>
                    <div className="model_likes_main">
                      
                      <ul className="like_total_list">
                      {bufferfollowers}
                   
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Single Post Overlay Likes Now end popup*/}

       {/*Single Post Overlay Likes Now end popup likes*/}

      <div className="modal fade post_modal singlelikesModal createPostCloseModal large_challenge_image" id="large_challenge_like_list_likes1" onKeyDown={this.singlePostLikeModalClose} data-backdrop="false" data-keyboard="true" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className='action-part'>
              <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close"  onClick={this.singlePostLikeModalClose}  title='Close'>&#x2715;</a>
            </div>
            <div className="modal-body">
              <div className='inner text-center'>
              <div className="likes_user_model">
                    <div className="likes_model_row">
                      <h1 className="like_title">Likes</h1>
                      
                    </div>
                    <div className="model_likes_main">
                      
                      <ul className="like_total_list">
                      {bufferlikefollowers}
                   
                      </ul>
                    </div>
                  </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      


      {/*Single Post Overlay Likes Now end popup likes*/}
      {/*delete post*/}
     <div className="modal fade post_modal post_modal_overlay deletePostCloseModalpopup" id="deletePostCloseModalpopup" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
        <div className='bg_overlay'></div>
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className='inner text-center'>
                <div className='title-main'>
                  <h6>Are you sure you want to delete this post?</h6>
                </div>
                <div className='action-part'>
                  <input type="hidden" id="delete_post_id" name="delete_post_id" />
                  <a href='javascript:void(0);'   onClick={(e) => this.checkDeletePost()}  className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close" title='Delete'>Delete</a>
                  <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*delete post*/}

        {/*delete comment popup*/}
              <div className="modal fade post_modal post_modal_overlay deleteCommentCloseModal" id="deleteCommentCloseModal" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="createPostCloseTitle" aria-hidden="true">
                <div className='bg_overlay'></div>
                <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className='inner text-center'>
                        <div className='title-main'>
                          <h6>Are you sure you want to delete?</h6>
                        </div>
                        <div className='action-part'>
                          <input type="hidden" id="delete_comment_id" name="delete_comment_id" />
                          <a href='javascript:void(0);' className='btn danger btn-post-discard' data-dismiss="modal" aria-label="Close"  onClick={this.checkDeleteComment} title='Discard'>Delete</a>
                          <a href='javascript:void(0);' className='btn cancel  btn-post-cancel' data-dismiss="modal" aria-label="Close" title='Cancel'>Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*delete comment popup*/}



    </React.Fragment> 
    );
  };  



  render() {
    const { isOpen, onClose } = this.props;
    //const { data } = this.state;
    const { isPopupOpenCommon, loading_common, error_common,post_common_id,postDetails_common,postData} = this.state;
     

    if (!isOpen) return null;
    return (
      <div className="popup-overlay">    
        <div className="popup-content">
          <button id="closepopup_common" style={{ display: "none" }}    onClick={onClose}>Close</button>
          {/*data ? <div>{data}</div> : <p>Loading...</p>*/}

         {/* <a href="javascript:;"  onClick={(e) => {this.openPopupCommon(e)}}  id="large_challenge_image_btn_common" type="button" > popup</a>*/}
          <a href="javascript:;"  style={{ display: "none" }}  data-toggle="modal" data-target="#large_challenge_image_common"   id="large_challenge_image_common_btn" type="button" >modal</a>
          {isPopupOpenCommon && loading_common ? (
                    <p></p>
                  ) : error_common ? (
                    <p></p>
                  ) : (
                isPopupOpenCommon && postDetails_common &&  this.renderDetailPageCommon(post_common_id)
                  )}
        </div>
      </div>
    );
  }
}

export default CommonPopup;


// WEBPACK FOOTER //
// ./src/CommonPopup.jsx